import DatePicker from "react-datepicker";
import { toUTCDate } from "../../helpers/Datetime";
import { useForm, Controller } from "react-hook-form";


export default function DateCustom({
    name,
    dateState,
    setDateState,
    placeholderText,
    dateFormat,
    defaultValue
}) {
    const { control } = useForm({
        mode: "onChange",
    });
    return (
        <Controller
            name={name}
            rules={{ required: true }}
            control={control}
            render={({ onChange, value }) => (
                <DatePicker
                    selected={
                        dateState ? new Date(dateState) : defaultValue ? new Date(defaultValue) : ""
                    }
                    maxDate={new Date()}
                    onChange={(e) => {
                        let newDate = toUTCDate(e)
                        // newDate = moment(newDate, 'YYYY-MM-DDTHH:mm:ss')
                        setDateState(newDate);
                        onChange(toUTCDate(e));
                    }}
                    showMonthDropdown
                    showYearDropdown
                    placeholderText={placeholderText}
                    dateFormat={dateFormat}
                    className="form-control"
                    showIcon
                    icon={
                        <img
                            src="/icons/calender.png"
                            className="date-picker-icon"
                            alt="date-icon"
                        ></img>
                    }
                />
            )}
        />
    )
}